/**
 * Return the digit string if the input looks like a phone number
 * per the rule: 7+ digits OR starts with 592.
 * Returns "" otherwise.
 */
export function extractPhone(raw) {
    if (!raw) return "";
    const digits = String(raw).replace(/\D/g, "");
    if (!digits) return "";
    if (digits.startsWith("592")) return digits;
    if (digits.length >= 7 && digits.length <= 15) return digits;
    return "";
}

export const GIVEAWAY_MESSAGE =
    "You have been entered to win $100,000 GYD to shop back on Ios.matrixshopping.com! " +
    "We need 1,000 entries before we generate a winner. SHARE WITH YOUR FRIENDS. " +
    "Remember, if your friends win they spend the money with you! " +
    "Enter here: https://Ios.matrixshopping.com";

export function whatsappShareUrl(text = GIVEAWAY_MESSAGE) {
    return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
